<span
  class="table-content"
  data-cy="table-column-content"
  [class.center]="hasSecondData"
  [class.bold]="columnTypes.isBasis"
  [class.offer]="isOfferActive"
  [class.demand]="isDemandActive"
  [class.deal]="columnTypes.isDeal"
  [class.deal--last-session]="isLastDeal"
  [class.deal--old-session]="isOldDeal"
  [class.quote]="columnTypes.isOffer || columnTypes.isDemand"
  [class.quote--last-session]="isLastQuote"
  [class.quote--old-session]="isOldQuote"
  [class.volume-high]="volumeDifference.isHigh"
  [class.volume-low]="volumeDifference.isLow"
  [class.changes-up]="changesDirection.isHigh"
  [class.changes-down]="changesDirection.isLow"
  [class.prev-deals-amount-diff-up]="prevDealsAmountDiffDirection.isHigh"
  [class.prev-deals-amount-diff-down]="prevDealsAmountDiffDirection.isLow"
  [class.deal-total]="isDealTotalPrice && mode !== 'light'"
  [class.around]="columnTypes.isTradeStart"
>
  <span
    *ngIf="columnTypes.isBasis"
    class="trend-indicator trend-indicator--{{ basisTrend || 'none' }}"
  >
  </span>
  <span
    *ngIf="hasData; else plug"
    [prlwTableTooltip]="isActive && columnTypes.isBasis ? null : columnId"
    [modifierType]="modifierType"
    [isDealTotal]="isDealTotal"
    [dealTime]="dealTime"
    [prevDealDate]="prevDealDate"
    [lastQuoteTime]="lastQuoteTime"
    [basisDetails]="basisDetails"
    [tariffDetails]="tariffDetails"
    [ngClass]="{
      highlight: hasTrendHighlight && !localPriceChanging,
      'highlight--first': hasSecondDataHighlight,
      'highlight-changes': hasChangesHighlight,
      'highlight-changes--up': highlightChangesDirection.isHigh,
      'highlight-changes--down': highlightChangesDirection.isLow,
      'with-text-tag': columnTypes.isBasis,
    }"
    [mode]="mode"
  >
    <span
      *ngIf="isCommonCell && !columnTypes.isTariff && !columnTypes.isLocalPrice"
      >{{ mainData | delimitNumber }}{{ asterisks }}</span
    >
    <prlw-text-tag-otp
      *ngIf="columnTypes.isBasis"
      [instrumentCode]="instrumentCode"
    ></prlw-text-tag-otp>
    <span *ngIf="columnTypes.isLocalPrice && localPriceChanging">
      <span class="dot dot--1"></span>
      <span class="dot dot--1"></span>
      <span class="dot dot--1"></span>
      <span class="dot dot--1"></span>
      <span class="dot dot--1"></span>
    </span>
    <span *ngIf="columnTypes.isLocalPrice && !localPriceChanging">
      {{ mainData | delimitNumber }}{{ asterisks }}
    </span>
    <span *ngIf="columnTypes.isChanges">
      {{ mainData | delimitNumber | signNumber }}
    </span>
    <span *ngIf="columnTypes.isPrevDealsAmountDiff">
      {{ mainData | delimitNumber | signNumber }}
    </span>
    <span
      *ngIf="columnTypes.isTariff"
      [class.bold]="tariffDetails?.source === 'Тарифная сетка'"
    >
      {{ mainData | delimitNumber }}
    </span>
    <span
      *ngIf="columnTypes.isTariff && isEditor && isEditable() && isHovered"
      (click)="handleOpenEditTraderTariffOverlay($event, instrumentCode)"
    >
      ✎
    </span>
    <span *ngIf="columnTypes.isTradeStart">
      {{ mainData | date: 'HH:mm' }}
    </span>

    <span
      class="progress-bar-wrapper"
      [class.progress-bar-wrapper--hovered]="isHovered"
      *ngIf="hasProgressBar"
    >
      <prlw-table-volume-progress-bar
        [current]="wrapNumber(mainData)"
        [forecast]="wrapNumber(secondData)"
      ></prlw-table-volume-progress-bar>
    </span>
  </span>
  <ng-container *ngIf="hasSecondData">
    <span
      *ngIf="hasData; else plug"
      [prlwTableTooltip]="columnId"
      [isSecond]="true"
      [ngClass]="{
        'highlight highlight--second': hasSecondDataHighlight,
      }"
      [mode]="mode"
    >
      {{ secondData | delimitNumber }}
    </span>
  </ng-container>
</span>
<ng-template #plug>
  <span
    [prlwTableTooltip]="columnId"
    [modifierType]="modifierType"
    [mode]="mode"
  >
    <span *ngIf="isCommonPlug">-</span>

    <span *ngIf="isTariffLoading">
      <span class="dot dot--1"></span>
      <span class="dot dot--2"></span>
      <span class="dot dot--3"></span>
    </span>

    <span class="no-station" *ngIf="isTariffError">
      <ng-container *ngIf="isPipe(); else notPipe">Труба</ng-container>
      <ng-template #notPipe>{{
        destination ? '-' : 'Нет станции'
      }}</ng-template>
    </span>
  </span>
</ng-template>
